import RectangleButton from '@/components/molecules/rectangleButton'
import Container from '@/components/templates/container'
import Title from './title'
import Description from './description'
import MainImage from './mainImage'
import Spacer from '@/components/atoms/spacer'
import { useMediaQuery } from '@mui/material'

const BookCourts = ({ title, description, image, ctaButton }) => {
  const isDesktop = useMediaQuery('(min-width: 1024px)')
  const base = 'relative w-full flex flex-col lg:flex-row justify-between gap-x-mediumDesktop mb-largeMobile lg:mb-largeDesktop'
  const baseContent = 'order-2 lg:order-1 relative w-full max-w-[550px]'
  const baseButton = 'block mt-smallMobile lg:mt-mediumDesktop mx-auto lg:mx-0'

  return (
    <Container outerClassName="mt-largeMobile lg:mt-largeDesktop">
      <div className={base}>
        <div className={baseContent}>
          {isDesktop && <Title text={title} />}
          <Description text={description} />
          <RectangleButton
            name={ctaButton.name}
            link={ctaButton.link}
            target="_blank"
            className={baseButton}
          />
        </div>
        {!isDesktop && <Title text={title} />}
        <MainImage image={image} />
      </div>
      <Spacer />
    </Container>
  )
}

export default BookCourts
